import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/demo.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: "BatteryAnalysis",
    components: {
        tree,
        iTable,
        IPagination,
        ChangeTime
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            carIdNumber: '',
            number: '',
            isSearch: true,
            activeName: 'first',
            orgId: '',
            height: '320',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                height: false,
                mutiSelect: false,
                serialNumber: false,
            },
            columns: [
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                },
                {
                    prop: "maintainCount",
                    label: this.$t('MaintenanceItemAnalysis.maintainCount'),
                    align: "center",
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            changeValue: ''
        };
    },
    mounted() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        onkeyUp() {
            this.currentPage = 1
            this.pageSize = 10
            this.queryCarMaintain(this.changeValue)
        },
        changeData(val) {
            console.log(val)
            this.changeValue = val
        },
        queryCarMaintain(changeValue) {
            console.log(changeValue)
            this.tableLoading = true
            let startTime = ''
            let endTime = ''
            if (changeValue) {
                if (changeValue.length > 0) {
                    startTime = changeValue[0] 
                    endTime = changeValue[1]
                }
            }
            let param = {
                orgId: Number(this.orgId),
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                carId: this.number,
                startTime: startTime,
                endTime: endTime
            };
            this.$store.dispatch('MaintenanceAnalysis/GET_SELECTCARMAINTAIN', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list;
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
                this.tableLoading = false
            }).catch(err => { this.tableLoading = false })
        },
        initQuery(item) {
            this.orgId = item.id
            this.queryCarMaintain(this.changeValue)
            this.$refs.changeTime.orgId = this.orgId
            this.$refs.changeTime.carIdNumber = ''
            this.$refs.changeTime.getcarCompare()
            this.$refs.changeTime.initQuery()
        },
        nodeClick(val) {
            this.orgId = val.label
            this.queryCarMaintain(this.changeValue)
            this.$refs.changeTime.orgId = val.label
            this.$refs.changeTime.carIdNumber = ''
            this.$refs.changeTime.getcarCompare()
            this.$refs.changeTime.initQuery()
        },
        rowClick(row) {
            this.carIdNumber = row.carId
            this.$refs.changeTime.carIdNumber = row.carId
            this.$refs.changeTime.getcarCompare()
            this.$refs.changeTime.isShow = false
            this.$refs.changeTime.initQuery()
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.queryCarMaintain(this.changeValue);
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
};
